import "./body.css";
import "./about.css";
import Header from "../components/header";
import Footer from "../components/footer";
import aboutImage from "../photos/about-2.jpg";

import React, { useState, useEffect } from "react";

function Navigation() {
  return (
    <nav className="homenavigation">
      <ul>
        <li>
          <a rel="noreferrer" target="_blank" href="http://eepurl.com/jikH5k">Subscribe</a>
        </li>
        <li>
          <a rel="noreferrer" target="_blank" href="https://a.co/d/09B0TpQS">Tales of Yimoa</a>
        </li>
        <li>
          <a rel="noreferrer" target="_blank" href="https://investwithknowledge.com">Invest with Knowledge!</a>
        </li>
        <li>
          <a rel="noreferrer" target="_blank" href="https://a.co/d/g5CAidz">The Gospel in 30 Days</a>
        </li>
        <li>
          <a rel="noreferrer" target="_blank" href="https://www.amazon.com/dp/1978457707/ref=sr_1_1?ie=UTF8&qid=1513331791&sr=8-1&keywords=Josiah+Swanson">Sub-Marine</a>
        </li>
        {/* <li>
          <a rel="noreferrer" target="_blank" href="https://beholdchristdaily.com/daily">Behold Christ Daily</a>
        </li> */}

      </ul>
    </nav>
  );
}

function About() {
  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  let [aboutList] = useState([
    "With the Great Commission as my mandate, I am passionate about training the next generation to live joyfully, courageously, and eternally-minded. My goal is to help families raise sons and daughters for the glory of God.",
    "Compelled by the Great Commission, I’m passionate about equipping the next generation to live with joy, courage, and eternal purpose. My aim is to support families as they raise sons and daughters who walk faithfully and boldly for the glory of God.",
  ]);
  let [aboutMessage, setAboutMessage] = useState(aboutList[0]);
  useEffect(() => {
    let randomIndex = getRandomInt(aboutList.length);
    setAboutMessage(aboutList[randomIndex]);
    document.title = "Josiah Swanson - About";
  }, [aboutList]);
  return (
    <>
      <section className="header about-header">
        <h1>Josiah Swanson</h1>
      </section>
      <section className="about-wrapper">
        <section className="mainbody">
          <section className="aboutleft">
            <img src={aboutImage} alt="About"></img>
          </section>
          <section className="aboutright">
            <p>
              {aboutMessage}
              <br></br>
              <br></br>
              <Navigation />
            </p>
          </section>
        </section>
      </section>
    </>
  );
}

export default About;
